import Events from 'components/Offers/components/Events';
import EventsMobile from 'components/Offers/components/Events/mobile';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterFitHeight from 'components/common/CollapsibleSideMenu/OuterFitHeight';
import OuterPathContent from 'components/common/CollapsibleSideMenu/OuterPathContent';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import { useDetectDevice } from 'hooks/useDetectDevice';
import React from 'react';

const EventsPage = () => {
  const { isMobile, isTablet } = useDetectDevice();

  if (isMobile || isTablet) {
    return (
      <OuterBodyContent>
        <EventsMobile />
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        <OuterPathContent>
          <OuterFitHeight>
            <Events />
          </OuterFitHeight>
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

export default EventsPage;
